import { Colors, Icon, Spacer, TagLabel, Text, FloatingBox, } from '@zapier/design-system';
import InAppSidebarSubheaderButton from './InAppSidebarSubheaderButton';
import { Fragment, useRef, useState } from 'react';
import { css } from '@emotion/react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { useUniversalNavContext } from '../../../hooks/useUniversalNavContext';
import { emitUserInteractionEvent } from '../../../utils/avroEvents';
const MenuStyles = ({ topbarSize }) => css({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxHeight: 'inherit',
    border: '1px solid transparent',
    boxSizing: 'border-box',
    overflow: 'auto',
    padding: '10px',
    width: topbarSize === 'medium' ? '275px' : '260px',
    left: '3px',
    top: '30px',
    minWidth: '150px',
    outline: 'none',
});
const MenuItemStyles = css({
    display: 'flex',
    gap: '10px',
    padding: '0.286rem 0.571rem',
    borderRadius: '6px',
    outline: 'none',
    cursor: 'pointer',
    fontSize: '1.072rem',
    position: 'relative',
    alignItems: 'center',
    columnGap: '10px',
    color: 'inherit',
    textDecoration: 'none',
    '&:focus, &:hover': {
        backgroundColor: Colors.cream,
    },
    '& span': {
        transition: 'none',
    },
});
const CreationItem = ({ description, href, icon, iconFilled, id, tag, target, title, }) => {
    const [isActive, setIsActive] = useState(false);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    return (isolateComponent("a", { css: MenuItemStyles, href: getFullyQualifiedURL(href), id: id, target: target, onFocus: () => setIsActive(true), onBlur: () => setIsActive(false), onMouseEnter: () => setIsActive(true), onMouseLeave: () => setIsActive(false), onClick: () => {
            emitUserInteractionEvent({
                event_action: 'click',
                option_selected: `UniversalSidebar CreateDropdown: ${title}`,
            });
        } },
        isolateComponent(Icon, { name: isActive ? iconFilled : icon, size: 28, color: isActive ? 'brand' : 'neutral800' }),
        isolateComponent("div", { css: {
                display: 'flex',
                flexDirection: 'column',
            } },
            isolateComponent("div", { css: { display: 'flex', alignItems: 'center' } },
                isolateComponent(Text, { type: "paragraph3Medium" }, title),
                tag && (isolateComponent(Fragment, null,
                    isolateComponent(Spacer, { width: 10 }),
                    isolateComponent(TagLabel, { size: "small", color: "lavender" }, tag)))),
            isolateComponent(Text, { type: "smallPrint1" }, description))));
};
export const CreateDropdown = ({ isCollapsed, items }) => {
    const { isCreateMenuOpen, setIsCreateMenuOpen, topbarSize } = useUniversalNavContext();
    const buttonRef = useRef(null);
    return (isolateComponent("div", { ref: buttonRef, style: { position: 'relative' } },
        isolateComponent(InAppSidebarSubheaderButton, { iconName: "formAdd", isCollapsed: isCollapsed, onClick: (event) => {
                event.stopPropagation();
                emitUserInteractionEvent({
                    event_action: 'click',
                    option_selected: `UniversalSidebar CreateDropdown ${isCreateMenuOpen ? 'close' : 'open'}`,
                });
                setIsCreateMenuOpen(!isCreateMenuOpen);
            }, text: "Create" }),
        isCreateMenuOpen && (isolateComponent(FloatingBox, { borderColor: "transparent", borderRadius: 10, onClickOutside: (event) => {
                if (buttonRef &&
                    buttonRef.current &&
                    !buttonRef.current.contains(event.target))
                    setIsCreateMenuOpen(false);
            } },
            isolateComponent("div", { css: MenuStyles({ topbarSize }) }, items.map((item) => (isolateComponent(CreationItem, Object.assign({}, item, { key: item.id })))))))));
};
//# sourceMappingURL=CreateDropdown.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
